/**
 * @module geo/components
 *
 */

import { Extension, ExtensionType } from "../types/extensions";
import {
  PanelWidgetExtensionProperties,
  WidgetPanelType
} from "../types/extensions/panel.widget";

import { Component } from "./component";
import { ComponentProperties } from "../types/component";

/**
 * Header for the app.
 * @since v2.0.1
 */
export class Header extends Component {
  defaultExtensionType = ExtensionType.WIDGET_PANEL;
  public buildExtension(properties: PanelWidgetExtensionProperties): Extension {
    const type = this.defaultExtensionType;
    properties.type = WidgetPanelType.HEADER;
    return { type, properties } as Extension;
  }
}

/**
 * Handle logo of layout.
 * @since v2.0.1
 */
export class Logo extends Component {}

/**
 * Handle title of layout
 * @since v2.0.1
 */
export class Title extends Component {}

/**
 * The print link component.
 * @since v2.0.1
 */
export class PrintLink extends Component {}
/**
 * The main search box.
 *
 * @since v2.0.1
 * example of configuration:
 *
 * ```
 *     'SearchBox': {
 *       visible: true,
 *       properties: {
 *             active: {searchesNames: ["Search departement"]}
 *         }
 *    },
 * ```
 */
export class SearchBox extends Component {
  properties: SearchBoxParameters = {};
}

/**
 * options for the search box.
 *
 */
export interface SearchBoxParameters extends ComponentProperties {
  /**
   * limit on listed searches
   */
  available?: SearchBoxOptions;
  /**
   * active listed searches
   */
  active?: SearchBoxOptions;
}

/**
 * the options to list searches
 */
export interface SearchBoxOptions {
  /**
   * limit on listed searches by id
   */
  searches?: string[];
  /**
   * limit on listed searches by name
   */
  searchesNames?: string[];
}

/**
 * A box containing main user info.
 * @since v2.0.1
 */
export class UserInfoHeader extends Component {}
